<h2 *ngIf="company" class="first_title">Dettagli società {{company.name}}</h2>
<app-pathbar-lem [pathbars]="pathbars"></app-pathbar-lem>
<div export-help></div>

<div class="content-page-wrapper">
  <div class="standardpanel">
  
  
    <!-- <div class="row">
      <div class="col-sm-12">
        <h4>Società</h4>
      </div>
    </div> -->
      <div class="titleblock mb-25">
        <h3 class="title1level mt-0">
          Società
        </h3>
      </div>
    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <label for="name">Nome</label>
        <input class="form-control" disabled="" type="text" name="name" autocomplete="organization" placeholder="inserire nome società" [value]="company?.name">
      </div>
      <div class="col-xs-12 col-sm-4"><label for="companyType">Tipo società</label>
        <input class="form-control" disabled="" type="text" name="companyType" placeholder="inserire tipo società" [value]="company?.type?.name">
      </div>
      <div class="col-xs-12 col-sm-4">
        <label for="companyScope">Tipo sede</label>
        <input class="form-control" disabled="" type="text" name="companyScope" placeholder="inserire sede" [value]="company?.scope?.name">
      </div>
    </div>
  
    <div class="row">
      <div class="col-xs-12 col-sm-8">
        <label for="vatnumber">Partita IVA</label>
        <input class="form-control" disabled="" type="text" name="vatnumber" placeholder="inserire partita iva" [value]="company?.vatNumber">
      </div>
  
      <div class="col-xs-12 col-sm-4"><label for="status">Stato</label>
        <input class="form-control" disabled="" placeholder="inserire stato" type="text" name="status"
          [value]="company?.statuses[company.statuses.length-1]?.status">
      </div>
    </div>
  
    <div class="row" style="margin-top: 15px">
      <div class="col-xs-12 col-sm-12">
        <h4> Proprietario</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <label for="nome">Tipo persona</label>
        <input class="form-control" disabled="" type="text" name="nome"
        [value]="company?.owner?.type === 'PHYSICAL_ENTITY' ? 'PERSONA FISICA' : 'PERSONA GIURIDICA'">
      </div>
      <div class="col-xs-12 col-sm-6">
        <label for="nome">Codice Fiscale</label>
        <input class="form-control" disabled="" type="text" name="nome" placeholder="inserire codice fiscale" [value]="company?.owner?.taxNumber">
      </div>
    </div>
    <ng-container *ngIf="company?.owner?.type === 'LEGAL_ENTITY'">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label for="">Nome</label>
          <input disabled [value]="company?.owner?.name" placeholder="inserire nome" id="" type="text" class="form-control">
        </div>
        <div class="col-xs-12 col-sm-6">
          <label for="">Partita IVA</label>
          <input disabled [value]="company?.owner?.vatNumber" placeholder="inserire partita IVA" id="" type="text" class="form-control">
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="company?.owner?.type === 'PHYSICAL_ENTITY'">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label for="">Nome</label>
          <input disabled [value]="company?.owner?.firstName" id="" placeholder="inserire nome" type="text" class="form-control">
        </div>
        <div class="col-xs-12 col-sm-6">
          <label for="">Cognome</label>
          <input disabled [value]="company?.owner?.lastName" id="" placeholder="inserire cognome" type="text" class="form-control">
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label for="">Email</label>
          <input disabled [value]="company?.owner?.email" id=""  placeholder="inserire email" name="email" autocomplete="email" type="text" class="form-control">
        </div>
      </div>
    </ng-container>
  
  
  </div>
</div>
